(function ($, window) {
    $(function () {
        // Recalc height
        recalcVH();

        window.addEventListener('resize', recalcVH);

        function recalcVH() {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', vh + 'px')
        }
    });
})(jQuery, window);